module.exports = __webpack_public_path__ + "static/media/traveling.3c059569.svg";